module.exports = __webpack_public_path__ + "img/groove_pay-integration.4684c118.png";